export enum MobileToolbarMode {
    tabs = 'tabs',
    elements = 'elements',
    selection = 'selection',
    editing = 'editing',
}

export const MOBILE_TOOLBAR_SET_MODE = 'MOBILE_TOOLBAR_SET_MODE';
